import React, { useState } from 'react';
import { IonModal } from '@ionic/react';
import { CloseButton } from '../globals/CloseButton';

type DirectoryModalProps = {
  content: any;
  backUrl: string;
};

export const DirectoryModal: React.FC<DirectoryModalProps> = ({ content, children, backUrl }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <IonModal
        isOpen={showModal}
        cssClass="directory-modal"
        swipeToClose={true}
        animated={true}
        showBackdrop={true}
        backdropDismiss={true}
        onDidDismiss={() => setShowModal(false)}
      >
        <div
          className={`hidden md:block modal-cross z-50 absolute top-6 left-6 md:top-9 md:left-9`}
        >
          <CloseButton to={backUrl} onClick={() => setShowModal(false)} />
        </div>
        {content}
      </IonModal>
      <button
        onClick={() => setShowModal(true)}
        className="bg-transparent text-black w-full"
      >
        <div className="h-full flex items-center md:flex md:flex-col">
          {children}
        </div>
      </button>
    </>
  );
};
